/** Runtime-safe index for object maps when the key is loosely typed (TS7053). */
export function idxMap<T>(map: Record<string, T>, key: any): T {
  return map[String(key) as keyof typeof map] as T;
}
